<template lang="pug">
//-
//- Fee not required
//-
template(v-if="value === null")
  template(v-if="isFemaleCategory")
    | {{ $t('simulator.notRequiredFemale') }}
  template(v-else)
    | {{ $t('simulator.notRequiredMale') }}

  //- Custom text for assetValuation category
  .font-size-small2(
    v-if="category === 'assetValuation'"
    style="line-height: 1rem") ({{ $t('simulator.assetValuationPortfolio') }})

//-
//- Fee to be defined
//-
template(v-else-if="value === 'toBeDefined'")
  | {{ $t('simulator.tbd') }}

//-
//- Fee is a number
//-
template(v-else-if="typeof value === 'number'")
  Amount(
    :value="value"
    :locale="locale"
    :currency="currency"
    is-integer)

//-
//- Default
//-
template(v-else)
  | {{ value }}
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import Amount from '~/components/Amount.vue'
  import type { FeeValue, FeeCategory } from '../types'

  export interface SimulatorCellProps {
    /** Fee value rendered by the cell. */
    value: FeeValue
    /** Active locale used for amount formatting. */
    locale: string
    /** Fee category used for translated fallback labels. */
    category: FeeCategory
    /** Currency used for amount formatting. */
    currency: string
  }

  //
  // Props and events
  //
  const props = defineProps<SimulatorCellProps>()

  //
  // Data
  //
  const femaleCategories = [
    'website',
    'auditFirmSemi',
    'assetValuation',
    'legalDueDiligence',
    'financialDueDiligence',
    'comfortLetter',
  ]

  //
  // Computed
  //
  const isFemaleCategory = computed(() => femaleCategories.includes(props.category))
</script>
